import { useTable } from "./useTable";

export const TypeReturn = ({ form, handleGetTableOrder }) => {
  const { columns } = useTable({
    form,
    handleGetTableOrder,
  });
  return { columns };
};
